import type { RefObject } from 'react';
import { useEffect } from 'react';

export function useApplyVideoObjectFit(
  videoEl: RefObject<HTMLVideoElement | null>,
) {
  useEffect(() => {
    function onLoaded() {
      if (!videoEl.current) {
        return;
      }

      const height = videoEl.current.videoHeight;
      const width = videoEl.current.videoWidth;

      videoEl.current.style.objectFit = height > width ? 'contain' : 'cover';
    }

    videoEl.current?.addEventListener('loadedmetadata', onLoaded);

    return () =>
      videoEl.current?.removeEventListener('loadedmetadata', onLoaded);
  }, [videoEl]);
}

export default useApplyVideoObjectFit;
